import React from "react"
import { InterventiTable } from "./InterventiTable"
import { InterventoDto } from "../../generated"
import { attach } from "../../common/componentExtensions"
import ImpiantiStore from "../interventiStore"
import { useEffect } from "react"
import Actions from "../InterventiActions"

export const InterventiCliente = attach((props: { idCliente: number, interventi: InterventoDto[], style?: React.CSSProperties }) => {
    useEffect(() => { Actions.getByCustomer(props.idCliente) }, [props.idCliente])
    return <InterventiTable interventi={props.interventi} style={props.style} />
}, ImpiantiStore, (store, props) => ({ interventi: store.get(props.idCliente?.toString()) || [] }))